export default __webpack_public_path__ + "static/media/SonuFull.cf1e7ea4.webp";